export const extensionsImages = ['png', 'jpg', 'jpeg', 'tiff', 'gif', 'webp', 'bmp']
export const extensionsDocs = ['doc', 'docx', 'xls', 'xlsx', 'pdf', 'ods', 'odt']
export const extensions = [...extensionsDocs, ...extensionsImages]

export function getExtension(upload) {
  if (!upload?.filename) {
    return null
  }
  /**
   *@type {string}
   */
  let ext = upload.filename.split('.')
  ext = ext[ext.length - 1]
  return ext.toLowerCase()
}

export function isAcceptable(upload) {
  const ext = getExtension(upload)
  return extensions.includes(ext)
}
